import http from './http';

export function updateSectionSitemap(payload) {
	return http.put('/admin/sitemap/sections', payload).then(resp => resp.data);
}
